import ComponentFactory from './ComponentFactory.js';
import Icons from './utils/Icons.js';
import { initShaderCanvases } from './components/Shaders.js';

class Main {
  constructor() {
    this.init();
  }

  init() {
    document.documentElement.classList.add('has-js');
    new ComponentFactory();
    Icons.load();
    initShaderCanvases();
  }
}
new Main();
